import InfoWidget from "./infoWidget";
import BannerWidget from "./bannerWidget";
import MultipleLargeWidget from "./multipleLargeWidget";
import MultipleSmallWidget from "./multipleSmallWidget";
import InfoPageScrollWidget from "./infoPageScrollWidget";
import GuestDetailsWidget from "./guestDetailsWidget";
import IFrameRendererHome from "./iFrameRendererHome";
import GuestItineraryWidget from "./guestItineraryWidget";


export const widgetDisplayType = [
  {
    type: 'Info Widget Type',
    CompName: InfoWidget,
  },
  {
    type: 'Banner Widget Type',
    CompName: BannerWidget,
  },
  {
    type: 'Info Scroll Widget Type',
    CompName: MultipleLargeWidget,
  },
  {
    type: 'Small Icon Scroll Widget Type',
    CompName: MultipleSmallWidget,
  },
  {
    type: "Guest Details",
    CompName: GuestDetailsWidget,
  },
  {
    type: "Guest Itinerary",
    CompName: GuestItineraryWidget,
  },
  {
    type: "URL iFrame Renderer (Open Default)",
    CompName: IFrameRendererHome
  },{
    type: "Info Page Scroll Widget",
    CompName: InfoPageScrollWidget
  },
];
